import { RcIcon } from '@/components/atoms/RcIcon'
import { RcButton } from '@/components/molecules/interactive/RcButton'
import { ModalTrigger } from '@/components/organisms/modal/ModalTrigger'
import { EmailParticipantForm } from '@/components/organisms/user/EmailParticipantForm'
import { RcTrans } from '@/components/atoms/RcTrans'
import { ModalConfiguration } from '@/components/organisms/modal/ModalConfiguration'
import { useCompetitionParticipants } from '@/entity/competition/useCompetitionParticipants'
import { useCompetitionActions } from '@/entity/competition/useCompetitionActions'

export const ContactTeamsModal: React.FC<{
  label: React.ReactNode
  teams: number[]
}> = ({ label, teams }) => {
  return (
    <ModalTrigger
      activation={handleOpen => (
        <RcButton
          onClick={handleOpen}
          variant='text'
          disabled={teams.length === 0}
          startIcon={<RcIcon icon={['fal', 'envelope']} size='xs' />}
          sx={{ textTransform: 'capitalize' }}
        >
          {label}
        </RcButton>
      )}
    >
      {({ handleClose }) => (
        <ParticipantContact teams={teams} handleClose={handleClose} />
      )}
    </ModalTrigger>
  )
}

export const ParticipantContact = ({
  teams,
  handleClose
}: {
  teams: number[]
  handleClose: any
}) => {
  const { emailParticipants } = useCompetitionActions()
  const { participants } = useCompetitionParticipants({
    request: { entryIds: teams }
  })

  // t('competition:contact.modal.title', { count })
  // t('competition:contact.modal.subtitle', { count })
  return (
    <>
      <ModalConfiguration />
      <EmailParticipantForm
        participants={participants?.map(it => it.participant?.id!) || []}
        onEmail={emailParticipants}
        onComplete={handleClose}
        title={
          <RcTrans
            i18nKey='competition:contact.modal.title'
            tOptions={{
              count: participants?.length,
              teamCount: teams.length
            }}
          />
        }
        subtitle={
          <RcTrans
            i18nKey='competition:contact.modal.subtitle'
            tOptions={{
              count: participants?.length
            }}
          />
        }
      />
    </>
  )
}
